import React, { useState, useCallback } from "react";
import { Icon, Input, Menu, Sidebar } from "semantic-ui-react";
import "./styles.css";
import {
  InputContainer,
  StyledLink,
  StyledLinkMenu,
  StyledLinkSubmenu,
} from "./styles";
import { menuAdmin } from "../../../utils/Utils";
import { getUserNode } from "../../../services/auth_node";
import ModalEvent from "../../Admin/ModalEvent";
import { IoIosSend } from "react-icons/io";

const MenuLateral = (props) => {
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const [isModalEventOpen, setIsModalEventOpen] = useState(false);

  const handleActiveIndex = useCallback(
    (index) => {
      if (index === activeIndex) {
        setActiveIndex(null);
        return;
      }

      setActiveIndex(index);
    },
    [activeIndex]
  );

  const userEmail = (getUserNode() && getUserNode().email) || "";

  const isAllowed = (link) =>
    !link.requiredEmails || link.requiredEmails.includes(userEmail);

  const filterMenu = (menu, searchTerm) => {
    const filterSublinks = (sublinks, term) => {
      return sublinks
        .filter(isAllowed)
        .filter((sublink) =>
          sublink.label.toLowerCase().includes(term.toLowerCase())
        );
    };

    return menu
      .filter(isAllowed)
      .map((item) => {
        const newItem = { ...item };

        if (newItem.subLinks) {
          const allowedSublinks = newItem.subLinks.filter(isAllowed);
          if (newItem.label.toLowerCase().includes(searchTerm.toLowerCase())) {
            newItem.subLinks = allowedSublinks;
            return allowedSublinks.length > 0 ? newItem : null;
          }
          newItem.subLinks = filterSublinks(newItem.subLinks, searchTerm);
          return newItem.subLinks.length > 0 ? newItem : null;
        }

        if (newItem.label.toLowerCase().includes(searchTerm.toLowerCase())) {
          return newItem;
        }

        return null;
      })
      .filter(Boolean);
  };

  return (
    <div>
      <Sidebar
        as={Menu}
        inverted
        vertical
        visible
        className="secondary-menu-node"
        onMouseLeave={() => props.onMouseLeave()}
        style={{
          left: "0px",
          transition: "left .5s ease-in-out",
          width: "250px",
        }}
      >
        <a
          align="center"
          href="/admin"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "2rem 1rem",
          }}
        >
          <br />
          <img
            src="https://files.voitto.com.br/assets/voitto-white-full.png"
            height="48"
          />
        </a>

        <InputContainer>
          <Input
            fluid
            placeholder="Pesquisar"
            onKeyPress={(e) => e.key == "Enter"}
            onChange={(e) => setSearch(e.currentTarget.value)}
          />
        </InputContainer>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "1rem 2.12rem",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setIsModalEventOpen(true);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              background: "#808080",
              color: "#fff",
              padding: "0.75rem 1.5rem",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "1.1rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              gap: "0.75rem",
              cursor: "pointer",
              justifyContent: "center",
            }}
          >
            <IoIosSend size={20} />
            CONTATO
          </a>
          {/* <a
            href="/admin/ranking/indicacao?id_evento=15"
            style={{
              display: "flex",
              alignItems: "center",
              background: "#4caf50",
              color: "#fff",
              padding: "0.75rem 1.5rem",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "1.1rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              gap: "0.75rem",
            }}
          >
            <span>
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                style={{ verticalAlign: "middle" }}
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="white"
                  strokeWidth="2"
                  fill="#4caf50"
                />
                <polygon points="10,8 16,12 10,16" fill="white" />
                <circle cx="18" cy="6" r="2" fill="#fff" opacity="0.7" />
              </svg>
            </span>
            LUANDA
          </a>
          <a
            href="/admin/ranking/indicacao?id_evento=16"
            style={{
              display: "flex",
              alignItems: "center",
              background: "#4caf50",
              color: "#fff",
              padding: "0.75rem 1.5rem",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "1.1rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              gap: "0.75rem",
            }}
          >
            <span>
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                style={{ verticalAlign: "middle" }}
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="white"
                  strokeWidth="2"
                  fill="#4caf50"
                />
                <polygon points="10,8 16,12 10,16" fill="white" />
                <circle cx="18" cy="6" r="2" fill="#fff" opacity="0.7" />
              </svg>
            </span>
            ARETHA
          </a> */}
        </div>
        {filterMenu(menuAdmin, search).map((linkObj, index) => {
          if (!linkObj.subLinks) {
            return (
              <StyledLink href={linkObj.link} key={index}>
                <span>{linkObj.label}</span>
                <Icon class="icon" name={linkObj.icon}></Icon>
              </StyledLink>
            );
          }

          const subLinksArr = linkObj.subLinks.map((subLinkObj, subIndex) => (
            <StyledLinkSubmenu href={subLinkObj.link} key={subIndex}>
              {subLinkObj.label}
            </StyledLinkSubmenu>
          ));

          return (
            <StyledLinkMenu
              key={index}
              active={activeIndex === index}
              onClick={() => handleActiveIndex(index)}
            >
              <div>
                <span>
                  <Icon
                    class="icon"
                    name={activeIndex === index ? "angle up" : "angle down"}
                  ></Icon>
                  {linkObj.label}
                </span>

                <Icon class="icon" name={linkObj.icon}></Icon>
              </div>

              {subLinksArr}
            </StyledLinkMenu>
          );
        })}
      </Sidebar>

      <ModalEvent
        open={isModalEventOpen}
        onClose={() => setIsModalEventOpen(false)}
      />
    </div>
  );
};

export default MenuLateral;
